import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { AdjustmentRuleAction } from '../adjustmentRule.action';

export const reloadAdjustmentRuleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    AdjustmentRuleAction.reload,
    AdjustmentRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      AdjustmentRuleAction.loadList.started(),
    ];
  }),
);
